import { render, staticRenderFns } from "./SellsyAILoader.vue?vue&type=template&id=01f7f99d&scoped=true&"
import script from "./SellsyAILoader.vue?vue&type=script&lang=js&"
export * from "./SellsyAILoader.vue?vue&type=script&lang=js&"
import style0 from "./SellsyAILoader.vue?vue&type=style&index=0&id=01f7f99d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f7f99d",
  null
  
)

export default component.exports